// extracted by mini-css-extract-plugin
module.exports = {"content":"cardGridEditorial_content__W4Qlm","titles":"cardGridEditorial_titles__jFcNz","bodies":"cardGridEditorial_bodies__erE89"};